import React from "react";
import MuiBackdrop from "@mui/material/Backdrop";
import PropTypes from "prop-types";

/**
 * Backdrop component wrapper for overlay backgrounds.
 * Wraps Material-UI Backdrop with theme integration.
 * 
 * @component
 * @example
 * <Backdrop open={open} onClick={handleClose}>
 *   <CircularProgress color="inherit" />
 * </Backdrop>
 */
const Backdrop = ({ children, ...props }) => {
  return <MuiBackdrop {...props}>{children}</MuiBackdrop>;
};

Backdrop.propTypes = {
  /**
   * The content of the component
   */
  children: PropTypes.node,
  /**
   * The component used for the root node
   */
  component: PropTypes.elementType,
  /**
   * If true, the backdrop is invisible
   */
  invisible: PropTypes.bool,
  /**
   * If true, the component is shown
   */
  open: PropTypes.bool.isRequired,
  /**
   * Callback fired when the component requests to be closed
   */
  onClick: PropTypes.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles
   */
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
  /**
   * Props applied to the Transition element
   */
  TransitionComponent: PropTypes.elementType,
  /**
   * The duration for the transition, in milliseconds
   */
  transitionDuration: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.shape({
      appear: PropTypes.number,
      enter: PropTypes.number,
      exit: PropTypes.number,
    }),
  ]),
};

// No defaultProps - maintain exact MUI Backdrop behavior

export default Backdrop;

